import { RouteBasePaths } from 'routes';
import { useAppSelector } from 'state/hooks';

export const useGetAutomationsBasePath = (): { automationsBasePath: RouteBasePaths } => {
  const isGlobalEditor = useAppSelector((state) => state.automations.isGlobalEditor);

  const automationsBasePath = isGlobalEditor ? RouteBasePaths.GlobalAutomations : RouteBasePaths.Automations;

  return { automationsBasePath };
};
